/**
 * @generated SignedSource<<3e9ab1af98aade041818f8e177f7fdfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TeamPipelineDeleteInput = {
  clientMutationId?: string | null;
  force?: boolean | null;
  id: string;
};
export type TeamRowDelete_Mutation$variables = {
  input: TeamPipelineDeleteInput;
};
export type TeamRowDelete_Mutation$data = {
  readonly teamPipelineDelete: {
    readonly deletedTeamPipelineID: string;
    readonly team: {
      readonly id: string;
      readonly pipelines: {
        readonly count: number;
      } | null;
    } | null;
  } | null;
};
export type TeamRowDelete_Mutation = {
  response: TeamRowDelete_Mutation$data;
  variables: TeamRowDelete_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TeamPipelineDeletePayload",
    "kind": "LinkedField",
    "name": "teamPipelineDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTeamPipelineID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPipelineConnection",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamRowDelete_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamRowDelete_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8534dec0beae033e92e5dd0d76b58994",
    "id": null,
    "metadata": {},
    "name": "TeamRowDelete_Mutation",
    "operationKind": "mutation",
    "text": "mutation TeamRowDelete_Mutation(\n  $input: TeamPipelineDeleteInput!\n) {\n  teamPipelineDelete(input: $input) {\n    deletedTeamPipelineID\n    team {\n      id\n      pipelines {\n        count\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02ec0ba83761ea91386d1f0bd43281c5";

export default node;
